import { EventEmitter } from 'events';
import { HeroRosterDispatcher, PlayerDispatcher } from '~/flux/dispatchers';
import { registerDispatchHandlers } from '~/Tools';
import { logError } from '~/logger';
import * as handlers from './handlers';

let playerId: string | null = null;

const HeroRosterStore = Object.assign({}, EventEmitter.prototype, {});
EventEmitter.call(HeroRosterStore);
export default HeroRosterStore;

PlayerDispatcher.register(
  registerDispatchHandlers({
    [PlayerDispatcher.PLAYER_LOGGED_IN]: (action: { player: { _id: string } }) => {
      try {
        playerId = action.player._id;
      } catch (err) {
        logError(err, { module: 'HeroRosterStore', func: 'PLAYER_LOGGED_IN' });
      }
    },
  })
);

HeroRosterDispatcher.register(
  registerDispatchHandlers({
    [HeroRosterDispatcher.DISMISS_HERO]: async (action: { heroHandle: string }) => {
      await handlers.dismissHero({ playerId }, action);
    },
  })
);
